/**
 * IndicatorTopo.jsx
 * Displays topographic information for specific indicators
 * Migration from front/src/components/IndicatorTopo.js
 */
import React, { memo } from 'react';
import { Typography } from '@mui/material';
import { printTextSize } from '../utils/entityHelpers';
import { OVERSEAS_TERRITORIES } from '../config/settings';

/**
 * Component to display topographic information for specific indicators
 * @param {Object} props - Component props
 * @param {Object} props.entity - Entity data
 * @param {string} props.entity.domaine - Territory domain identifier
 * @param {string} props.entity.port_rattachement - Reference port for coastal indicators
 * @param {string} props.indicatorKey - Current indicator key
 * @returns {React.ReactElement} IndicatorTopo component
 */
const IndicatorTopo = ({
  entity: {
    domaine,
    port_rattachement,
  } = {},
  indicatorKey,
}) => (
  <>
    {/* Coastal reference port for submersion indicator (R3) - Only for overseas territories */}
    {indicatorKey === 'R3' && port_rattachement && OVERSEAS_TERRITORIES.isOverseas(domaine) && (
      <Typography sx={{ ...printTextSize, mb: 2 }}>
        Port de référence : <b>{port_rattachement}</b>
      </Typography>
    )}
  </>
);

IndicatorTopo.displayName = 'IndicatorTopo';

export default memo(IndicatorTopo);
